// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SyntheticMonitoringSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="SyntheticMonitoringSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M12.312 11.706H7.688c-1.115 0-1.725.438-1.513 1.763.197 1.241.595 2.519.74 3.013.277.943 1.135 1.303 2.117 1.303h1.936c.982 0 1.84-.36 2.117-1.303.145-.494.542-1.772.74-3.013.212-1.325-.398-1.763-1.513-1.763m3.203-5.293c0-2.32-.159-4.199-2.477-4.199H6.995c-2.318 0-2.477 1.88-2.477 4.198s-.54 4.198 1.779 4.198h7.265c2.318 0 1.953-1.88 1.953-4.197m-9.007-.35a1.164 1.164 0 1 1 2.328 0 1.164 1.164 0 0 1-2.328 0M10 9.053c-.956 0-1.731-.323-1.731-.72h3.462c0 .397-.775.72-1.731.72m2.328-1.826a1.164 1.164 0 1 1 0-2.328 1.164 1.164 0 0 1 0 2.328m4.17-2.477-.595-.255c.088.64.088 1.314.088 1.918q.001.425.012.83a25 25 0 0 1 .005 1.047l.524-.212a.6.6 0 0 0 .23-.434v-2.51a.46.46 0 0 0-.263-.384M4.014 7.515C4.027 7.16 4.042 6.792 4.042 6.412c0-.609 0-1.288.09-1.933L3.503 4.75a.46.46 0 0 0-.264.383v2.51a.6.6 0 0 0 .23.435l.521.21a29 29 0 0 1 .024-.773m10.417 7.729c.285-.365.67-1.025.402-1.75-.093-.252-.1-.377-.003-.453.153-.118.352.037.505.207.806.896 1.42 2.395.788 3.365-.212.326-.55.571-.967.571a1.106 1.106 0 0 1-1.106-1.106c0-.333.226-.635.381-.834m-8.86 0c-.285-.365-.67-1.025-.402-1.75.092-.252.1-.377.002-.453-.152-.118-.35.037-.504.207-.806.896-1.42 2.395-.789 3.365.213.326.552.571.968.571a1.106 1.106 0 0 0 1.106-1.106c0-.333-.226-.635-.382-.834" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SyntheticMonitoringSignetIcon = /* @__PURE__ */ Object.assign(
  SyntheticMonitoringSignetIconComponent,
  { displayName: 'SyntheticMonitoringSignetIcon' },
);
